import { GetServerSidePropsContext, NextPageContext } from 'next';
import { getServerCookie } from '../utils/CookieUtils';
import { COOKIE } from './constants';
import Cookies from 'universal-cookie';

export const getRecommendationId = (
  ctx?: NextPageContext | GetServerSidePropsContext,
): string | undefined => {
  if (!ctx) {
    const cookies = new Cookies();
    // TODO: Remove this legacy recommended user 400 days after it is deployed (that's the max time a cookie can be stored in the browser)
    // See https://distilledsch.tpondemand.com/entity/114667-remove-fallback-on-legacy-ddrecommendeduser
    const legacyRecommendedUser = cookies.get(
      COOKIE.DD_LEGACY_RECOMMENDED_USER,
    );
    const clientID = cookies.get(COOKIE.DD_CLIENT_ID);
    const clientUID = cookies.get(COOKIE.DD_CLIENT_UID);
    return clientUID ?? legacyRecommendedUser ?? clientID;
  }

  // TODO: Remove this legacy recommended user 400 days after it is deployed (that's the max time a cookie can be stored in the browser)
  // See https://distilledsch.tpondemand.com/entity/114667-remove-fallback-on-legacy-ddrecommendeduser
  const legacyRecommendedUser = getServerCookie(
    COOKIE.DD_LEGACY_RECOMMENDED_USER,
    ctx,
    true,
  ) as string | undefined;
  const clientID = getServerCookie(COOKIE.DD_CLIENT_ID, ctx, true) as
    | string
    | undefined;
  const clientUID = getServerCookie(COOKIE.DD_CLIENT_UID, ctx, true) as
    | string
    | undefined;
  return clientUID ?? legacyRecommendedUser ?? clientID;
};
